export default __webpack_public_path__ + "img/app-page/Search.81e2993083f3a115d822cb52724e8910.png";